import { toast } from 'react-toastify';

export const NotificationManager = {
  success: (msg: string, title?: string) => toast.success(title ? `${title}: ${msg}` : msg, {
    autoClose: 5000,
  }),
  error: (msg: string, title?: string) => toast.error(title ? `${title}: ${msg}` : msg,
    {
      autoClose: 1000,
    }
  ),
  info: (msg: string, title?: string) => toast.info(title ? `${title}: ${msg}` : msg, {
    autoClose: 5000,
  }),
  warning: (msg: string, title?: string) => toast.warn(title ? `${title}: ${msg}` : msg,
    {
      autoClose: 5000,
    }
  ),
};
